import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, Loading } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RoulettePage } from '../roulette/roulette';
import { AuthService } from '../../providers/auth/auth';
import { RegisterPage } from '../register/register';
import { PasswordPage } from '../password/password';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  loginForm: FormGroup;
  loading: Loading;

  constructor(public navCtrl: NavController, private formBuilder: FormBuilder, private auth: AuthService, private tCtrl: ToastController, private loadingCtrl: LoadingController) {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.required]
    });
  }

  ionViewDidLoad() {
    this.init();
  }

  private init() {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.required]
    });
  }

  login() {
    this.loading = this.loadingCtrl.create({
    });
    this.loading.present();
    let loginValues = this.loginForm.value;
    if(this.loginForm.valid){
      this.auth.signInWithEmail(loginValues).then((response) => {
        let toast = this.tCtrl.create({
          message: "Login erfolgreich",
          duration: 3000,
          position: 'top'
        });
        toast.present();
        this.loading.dismiss();
        let user_uid = response.user.uid;
        this.navCtrl.setRoot(RoulettePage);
      }).catch((error) => {
        // console.log("login error: ", error);
        if(error.code == "auth/user-not-found") {
          let toast = this.tCtrl.create({
            message: "Benutzer nicht gefunden",
            duration: 3000,
            position: 'top'
          });
          toast.present();
          this.loading.dismiss();
        } else if (error.code == "auth/wrong-password") {
          let toast = this.tCtrl.create({
            message: "Ungültige E-Mail oder Passwort",
            duration: 3000,
            position: 'top'
          });
          toast.present();
          this.loading.dismiss();
        } else {

        }
      });
    } else {
      let toast = this.tCtrl.create({
        message: "Eingabe ungültig",
        duration: 3000,
        position: 'top'
      });
      toast.present();
      this.loading.dismiss();
      return false;
    }
  }

  toRegister() {
    this.navCtrl.push(RegisterPage);
  }

  forgotPassword() {
    this.navCtrl.push(PasswordPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts